import axios from 'axios';
import { isExpired } from 'react-jwt';

// Funciones para obtener y refrescar tokens
const getAccessToken = () => localStorage.getItem('accessToken');
const getRefreshToken = () => localStorage.getItem('refreshToken');
const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
};

// Crear una instancia de Axios:
const api = axios.create({
  baseURL: process.env.REACT_APP_URL_DIR,//'http://localhost:3001',
});

// Interceptor de solicitud para añadir el token de acceso
api.interceptors.request.use(
  async (config) => {
    let token = getAccessToken();
    if (isExpired(token)) {
      const refreshToken = getRefreshToken();
      if (refreshToken) {
        try {
          const { data } = await axios.post('/refresh', { token: refreshToken });
          setTokens(data.accessToken, data.refreshToken);
          token = data.accessToken;
        } catch (error) {
          console.error('No se pudo refrescar el token', error);
          // Redirigir al login si el refresh token también ha expirado
          window.location.href = '/login';
        }
      } else {
        // Redirigir al login si no hay refresh token
        window.location.href = '/login';
      }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta para manejar el refresco del token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = getRefreshToken();
      try {
        const { data } = await axios.post('/refresh-token', { token: refreshToken });
        setTokens(data.accessToken, data.refreshToken);
        originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        console.error('No se pudo refrescar el token', refreshError);
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;